import { useAuth } from "../../lib/auth";
import { useEffect, useState } from "react";
import Section from "../Section";
import { useTranslations } from "../../contexts/Translation";
import { useApiData } from "../../contexts/ApiData";
import SystemMessage from "../SystemMessage/Index";
import Button from "../Button/Button";
import { H2 } from "../Headers/Headings";
import LogoImage from "../LogoImage";
import styles from "./Invitation.module.css";

const getOrgIdFromUrl = (path: string) => {
  // Extract orgId from an url like this: https://go.feedbackjourney.com/join?org=148926fa-4a6a-4411-b008-eac51b255a18
  const url = new URL(path);
  const orgId = url.searchParams.get("org");
  if (orgId) {
    return orgId;
  }
};

export const JoinOrganization = () => {
  const { user, getAccessToken } = useAuth();
  const { get, post } = useApiData();
  const t = useTranslations("join");
  const [org, setOrg] = useState<any>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [urlError, setUrlError] = useState<string | null>(null);

  const [orgId, setOrgId] = useState<string | null>(null);

  const lookupOrganization = (e: any) => {
    setUrlError(null);
    const orgId = getOrgIdFromUrl(e.currentTarget.value);
    if (!orgId) {
      setUrlError(t("invalidLink"));
      return;
    }
    setOrgId(orgId);
  };

  useEffect(() => {
    const fetchOrg = async () => {
      const response = await get(`/org/${orgId}`);
      if (!response) {
        setUrlError(t("orgFetchError"));
        return;
      }
      setOrg(response);
    };

    if (orgId && !org && user) {
      fetchOrg();
    }
  }, [get, orgId, user, t, org]);

  if (error) {
    return <SystemMessage message={error} isError />;
  }

  if (!org) {
    return (
      <Section>
        <H2>{t("joinByLinkHeading")}</H2>
        <label>
          {t("pasteLink")}
          <input className={styles.lookupField} type='text' onBlur={lookupOrganization} />
          {urlError && <p className={styles.error}>{urlError}</p>}
          <Button onClick={() => lookupOrganization}>{t("okButton")}</Button>
        </label>
      </Section>
    );
  }

  const joinFn = async () => {
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await post(`/organization/${org.id}/users`, {});
      if (response) {
        await getAccessToken({ refresh: true });
        window.location.href = "/";
      } else {
        setError("join.joinFailed");
      }
    } catch {
      setError("join.joinFailed");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Section className={styles.hero}>
      {t("aboutTo", org.name)}
      {org.logo && (
        <div className={styles.logoWrapper}>
          <LogoImage src={`/images/logo/${org.id}`} alt={org.name} maxHeight={100} maxWidth={150} />
        </div>
      )}
      <div className={styles.buttonRow}>
        <Button variant='large' onClick={joinFn} disabled={isSubmitting}>
          {isSubmitting ? t("joining") : t("join", org.name)}
        </Button>
      </div>
      {error && <SystemMessage message={error} isError />}
    </Section>
  );
};
